import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api.js';

/** 377 (#1233, design F): a car's hosts as chips, or "No host". */
export function CarHostsChips({ hosts }: { hosts: Array<{ id: string; name: string }> }) {
  if (hosts.length === 0)
    return (
      <span className="whitespace-nowrap rounded-full bg-surface-feature px-2.5 py-0.5 text-xs font-bold text-steel">
        No host
      </span>
    );
  return (
    <span className="inline-flex flex-wrap gap-1.5">
      {hosts.map((h) => (
        <span
          key={h.id}
          className="whitespace-nowrap rounded-full bg-brand-blue-soft px-2.5 py-0.5 text-xs font-bold text-primary-deep"
        >
          {h.name}
        </span>
      ))}
    </span>
  );
}

/**
 * 377 (design F): the booking page names the car's hosts — the people who handle it. Read from the car (staff see
 * `hosts` on `GET /cars/:id`); if that read is refused or fails, nothing is shown rather than a wrong "No host".
 */
export function CarHostsLine({ carId }: { carId: string }) {
  const car = useQuery({
    queryKey: ['car', carId, 'hosts'],
    queryFn: () => api.get<{ hosts?: Array<{ id: string; name: string }> }>(`/cars/${carId}`),
    retry: false,
    staleTime: 60_000,
  });
  if (!car.data || !Array.isArray(car.data.hosts)) return null;
  return (
    <p data-testid="car-hosts-line" className="flex flex-wrap items-center gap-2 text-sm">
      <span className="text-steel">Hosts:</span>
      <CarHostsChips hosts={car.data.hosts} />
    </p>
  );
}
